import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const aggregatedStatisticSelector = ({ aggregatedStatistic }: ReducerState) => aggregatedStatistic;
export const aggregatedStatisticLoadingSelector = createSelector(
  aggregatedStatisticSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
